/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Sticky.vue.js?vue&type=template&id=70ed42a5!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Sticky.vue?vue&type=template&id=70ed42a5"
import script from "./Sticky.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Sticky.vue?vue&type=script&lang=ts&setup=true"
export * from "./Sticky.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Sticky.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Sticky.vue.postcss?vue&type=style&index=0&id=70ed42a5&prod&lang=postcss!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Sticky.vue?vue&type=style&index=0&id=70ed42a5&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports